import { Navigate } from 'react-router-dom';

import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const CheckinSteps = withLazyFallback(() => import('components/Patient/checkin/CheckinSteps'));

const CHECK_IN = [
  { path: 'checkin', element: <CheckinSteps /> },
  { path: 'checkin/:step_id', element: <CheckinSteps /> },
  { path: 'checkin/:step_id/:substep_id', element: <CheckinSteps /> },
  {
    path: 'checkin/*',
    element: <Navigate replace relative="path" to=".." />
  }
];

export default CHECK_IN;
